import { render, staticRenderFns } from "./collect_index.vue?vue&type=template&id=33f01100"
import script from "./collect_index.vue?vue&type=script&lang=js"
export * from "./collect_index.vue?vue&type=script&lang=js"
import style0 from "./collect_index.vue?vue&type=style&index=0&id=33f01100&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports